import { DATE_WITH_TIME_FORMAT, formatDateToLocalSimple } from '@shared/utils';

export class EmailDataModel {
  name: string;
  sentDate: string;
  deliveredDate: string;
  readDate: string;
  failedDate: string;
  failedReason: string;

  constructor(dto: any) {
    this.name = dto.memberName || '';
    this.sentDate = dto.emailSentDate ? formatDateToLocalSimple(dto.emailSentDate, DATE_WITH_TIME_FORMAT) : '-';
    this.deliveredDate = dto.emailStatus === 'Delivered' || dto.emailStatus === 'Opened'
      ? formatDateToLocalSimple(dto.emailSentDate, DATE_WITH_TIME_FORMAT)
      : '-';
    this.readDate = dto.dateOpened ? formatDateToLocalSimple(dto.dateOpened, DATE_WITH_TIME_FORMAT) : '-';
    this.failedDate = dto.emailStatus === 'Dropped' || dto.emailStatus === 'Failed' || dto.emailStatus === 'Bounce'
      ? formatDateToLocalSimple(dto.emailSentDate, DATE_WITH_TIME_FORMAT)
      : '-';
    this.failedReason = dto.failedReason || null;
  }
}
